import { marked } from 'marked';
import DOMPurify from 'dompurify';

/**
 * Renderiza um documento legal (markdown) em HTML sanitizado.
 *
 * `breaks: false` é explícito de propósito: AiSearchResult roda
 * `marked.setOptions({ gfm: true, breaks: true })` no import, e essa opção é
 * global. Como os .md legais são quebrados em ~78 colunas, cada quebra do
 * arquivo virava um <br> na tela.
 */
export function renderLegalMarkdown(markdown) {
  return DOMPurify.sanitize(marked.parse(markdown, { gfm: true, breaks: false }));
}
